import { createRef, RefObject, useRef } from "react";

function useDynamicRefs<T>(): {
    getRef: (id: string) => RefObject<T | null>;
} {
    const refs = useRef<Record<string, RefObject<T | null>>>({});

    const getRef = (id: string): RefObject<T | null> => {
        if (!refs.current[id]) {
            refs.current[id] = createRef<T>();
        }
        return refs.current[id];
    };

    return { getRef };
}

export default useDynamicRefs;
